import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NavBar from '../shared/components/Navbar';
import Footer from '../shared/components/Footer';

const BlogPostPage = () => {
  const { postSlug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [postUrl, setPostUrl] = useState(null);
  const [postTitle, setPostTitle] = useState('');

  const WP_API_URL = 'https://mycashcanvas.com/wp/wp-json/wp/v2/posts';

  useEffect(() => {
    setLoading(true);
    fetch(`${WP_API_URL}?slug=${encodeURIComponent(postSlug)}&_embed`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch post: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setPostUrl(data[0].link || '');
          setPostTitle(data[0].title.rendered.replace(/<[^>]*>/g, ''));
        } else {
          setError('Post not found');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching post:', err);
        setError(err.message || 'Failed to load post');
        setLoading(false);
      });
  }, [postSlug]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col bg-background-main">
        <NavBar />
        <main className="flex-1 max-w-4xl mx-auto pt-28 pb-10 px-4">
          <p className="text-center py-8">Loading…</p>
        </main>
        <Footer />
      </div>
    );
  }

  if (error || !postUrl) {
    return (
      <div className="min-h-screen flex flex-col bg-background-main">
        <NavBar />
        <main className="flex-1 max-w-4xl mx-auto pt-28 pb-10 px-4">
          <div className="mb-6">
            <button onClick={() => navigate(-1)} className="text-btn-secondary hover:underline">&larr; Back</button>
          </div>
          <p className="text-center py-8 text-red-500">{error || 'Post not found'}</p>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-background-main">
      <NavBar />
      <main className="flex-1 max-w-6xl mx-auto pt-28 pb-10 px-4 w-full">
        <div className="flex items-center gap-3 mb-6">
          <button 
            onClick={() => navigate(-1)} 
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded transition-colors font-medium"
          >
            ← Back
          </button>
          <h1 className="text-2xl font-bold flex-1">{postTitle}</h1>
          <a 
            href={postUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-4 py-2 bg-btn-primary text-white rounded hover:bg-opacity-90 transition-colors font-medium whitespace-nowrap"
          >
            Open in a New Tab ↗
          </a>
        </div>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <iframe 
            src={postUrl}
            title={postTitle}
            className="w-full h-full border-0"
            style={{ minHeight: '900px' }}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPostPage;
